/** Altezza condivisa tra header sidebar (tenant) e top bar pagina */
export const SHELL_TOPBAR_HEIGHT = 'h-14';

export const SHELL_TOPBAR_BORDER = 'border-topbar';

export const SHELL_TOPBAR_SURFACE = 'bg-topbar';
